<template>
  <div class="mono-nav">
    <div class="page-header">
      <div class="greeting">Bonjour, {{this.$store.state.user.prenom}}&nbsp;!</div>
      <div class="date-label">
        Tableau de bord moniteur · {{new Date().toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})}}
      </div>
    </div>

    <div class="info-banner">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        style="flex-shrink: 0; margin-top: 1px"
      >
        <path
          d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
          stroke="#92400e"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <span><strong>Pensez à valider vos heures en fin de journée.</strong></span>
    </div>

    <div class="section-label">Navigation</div>

    <div class="menu-list">
      <!-- PLANNING -->
      <div class="menu-item planning" @click="goToPlanning">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect
              x="3"
              y="4"
              width="18"
              height="18"
              rx="3"
              stroke="#2563eb"
              stroke-width="1.8"
            />
            <path
              d="M3 9H21"
              stroke="#2563eb"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <path
              d="M8 2V6M16 2V6"
              stroke="#2563eb"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <path
              d="M7 13H11M7 17H13"
              stroke="#2563eb"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <div class="item-body">
          <div class="item-label">Planning</div>
          <div class="item-link">Voir le planning →</div>
        </div>
        <div class="item-right">
          <div class="chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#c0b9b0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- MA LISTE EXAM -->
      <div class="menu-item exam" @click="goToExamList">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect
              x="4"
              y="2"
              width="16"
              height="20"
              rx="2"
              stroke="#ea580c"
              stroke-width="1.8"
            />
            <path
              d="M8 7H16M8 11H16M8 15H12"
              stroke="#ea580c"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <div class="item-body">
          <div class="item-label">Ma liste exam</div>
          <div class="item-link">Voir ma liste d'examen →</div>
        </div>
        <div class="item-right">
          <div class="chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#c0b9b0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- RECAP HEURES -->
      <div class="menu-item recap" @click="goToRecap">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" stroke="#16a34a" stroke-width="1.8" />
            <path
              d="M12 7V12L15 14"
              stroke="#16a34a"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="item-body">
          <div class="item-label">Récap heures</div>
          <div class="item-link">Voir le détail →</div>
        </div>
        <div class="item-right">
          <div class="chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#c0b9b0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- ÉLÈVE EXAM -->
      <div class="menu-item eleve-exam" @click="goToEleveList">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="10" cy="7" r="4" stroke="#7c3aed" stroke-width="1.8" />
            <path
              d="M3 20C3 17.2386 6.13401 15 10 15"
              stroke="#7c3aed"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <path
              d="M17 13L19 15L22 12"
              stroke="#7c3aed"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="item-body">
          <div class="item-label">Élève Exam</div>
          <div class="item-link">Voir les élèves →</div>
        </div>
        <div class="item-right">
          <div class="chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#c0b9b0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- DECONNEXION -->
      <div class="menu-item deconnexion" @click="deconnexion">
        <div class="item-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M16 17L21 12L16 7"
              stroke="#475569"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21 12H9"
              stroke="#475569"
              stroke-width="1.8"
              stroke-linecap="round"
            />
            <path
              d="M9 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9"
              stroke="#475569"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <div class="item-body">
          <div class="item-label">Déconnexion</div>
          <div class="item-sub">Se déconnecter du compte</div>
        </div>
        <div class="item-right">
          <div class="chevron">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#c0b9b0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Dialog
    v-model:visible="showCoursDialog"
    modal
    :closable="false"
    :closeOnEscape="false"
    :dismissableMask="false"
    header="Cours à terminer"
    :style="{ width: showFicheCours ? '70rem' : '55rem', maxWidth: '95vw' }"
  >
    <template v-if="!showFicheCours">
      <p class="cours-dialog-desc">
        Merci de terminer les cours suivants pour continuer.
      </p>
      <DataTable :value="coursNonTermines" dataKey="id" tableStyle="width: 100%">
        <Column header="Date">
          <template #body="slotProps">{{ slotProps.data.date }} · {{ slotProps.data.heureDebut }} - {{ slotProps.data.heureFin }}</template>
        </Column>
        <Column field="lieu" header="Lieu"></Column>
        <Column field="eleve" header="Élève"></Column>
        <Column header="Action">
          <template #body="slotProps">
            <button class="btn btn-primary" @click="terminerCours(slotProps.data)">Terminer le cours</button>
          </template>
        </Column>
      </DataTable>
    </template>
    <template v-else>
      <FicheCours :idRdv="idRdvFiche" @cancelFicheRdv="onFicheCoursDone" />
    </template>
  </Dialog>
</template>
<script>
import FicheCours from "@/components/Moniteur/Planning/FicheCours.vue";

export default {
    components: { FicheCours },

    data() {
      return {
        // Dialog bloquant tant qu'il reste des cours passés non terminés par le moniteur
        coursNonTermines: [],
        showCoursDialog: false,
        showFicheCours: false,
        idRdvFiche: null,
      }
    },

    mounted() {
      this.getCoursNonTermines();
    },

    methods: {
        getCoursNonTermines() {
          window.api
            .get("/moniteur/" + this.$store.state.user.id + "/cours-non-termines", {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then((response) => {
              this.coursNonTermines = response.data.cours;
              this.showCoursDialog = this.coursNonTermines.length > 0;
            })
            .catch((error) => { console.log(error); });
        },

        terminerCours(item) {
          this.idRdvFiche = item.id;
          this.showFicheCours = true;
        },

        onFicheCoursDone() {
          this.showFicheCours = false;
          this.idRdvFiche = null;
          // Réactualise : le cours terminé ne sera plus renvoyé, et le dialog se fermera
          // tout seul s'il n'en reste plus aucun
          this.getCoursNonTermines();
        },

        goToPlanning(){
            this.$router.push({ name: "PlanningMonoFront" });
        },

        goToRecap(){
            this.$router.push({name: 'mono_heure'});
        },

        goToExamList(){
            this.$router.push({ name: "planning_exams" });
        },

        goToEleveList(){
            this.$router.push({ path: '/eleves/exam' });
        },

        deconnexion() {
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            localStorage.removeItem("user_info");
            localStorage.removeItem("user_access");
            this.$router.push({name: 'index'});
        },

    },
};
</script>
<style scoped>

div.mono-nav{
    text-align: left;
    width: 80%;
    margin: auto;
    margin-top: 4rem;
}

.page-header {
  margin-bottom: 18px;
}

.greeting {
  font-weight: 800;
  font-size: 24px;
  color: #1a1714;
  letter-spacing: -0.5px;
  line-height: 1.15;
}

.date-label {
  font-size: 13px;
  color: #7a7168;
  margin-top: 3px;
}

.info-banner {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-bottom: 22px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.5;
}

.section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #7a7168;
  margin-bottom: 10px;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-item {
  background: #ffffff;
  border: 1px solid #e8e4de;
  border-radius: 16px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition:
    transform 0.12s ease,
    box-shadow 0.12s ease;
  position: relative;
  overflow: hidden;
}

.menu-item:active {
  transform: scale(0.985);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.menu-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  border-radius: 16px 0 0 16px;
}

.menu-item.planning::before {
  background: #2563eb;
}
.menu-item.exam::before {
  background: #ea580c;
}
.menu-item.recap::before {
  background: #16a34a;
}
.menu-item.eleve-exam::before {
  background: #7c3aed;
}
.menu-item.deconnexion::before {
  background: #475569;
}

.item-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-item.planning .item-icon {
  background: #eff4ff;
}
.menu-item.exam .item-icon {
  background: #fff4ec;
}
.menu-item.recap .item-icon {
  background: #f0fdf4;
}
.menu-item.eleve-exam .item-icon {
  background: #f5f3ff;
}
.menu-item.deconnexion .item-icon {
  background: #f1f5f9;
}

.item-body {
  flex: 1;
  min-width: 0;
}

.item-label {
  font-weight: 700;
  font-size: 14px;
  color: #1a1714;
  line-height: 1.2;
}

.item-sub {
  font-size: 12px;
  color: #7a7168;
  margin-top: 2px;
  line-height: 1.4;
}

.item-link {
  font-size: 12px;
  font-weight: 500;
  margin-top: 2px;
}
.menu-item.planning .item-link {
  color: #2563eb;
}
.menu-item.exam .item-link {
  color: #ea580c;
}
.menu-item.recap .item-link {
  color: #16a34a;
}
.menu-item.eleve-exam .item-link {
  color: #7c3aed;
}
.menu-item.deconnexion .item-link {
  color: #475569;
}

.item-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.item-stat {
  font-weight: 800;
  font-size: 24px;
  line-height: 1;
}

.menu-item.planning .item-stat {
  color: #2563eb;
}
.menu-item.exam .item-stat {
  color: #ea580c;
}
.menu-item.eleve-exam .item-stat {
  color: #7c3aed;
}

.item-stat-label {
  font-size: 10px;
  color: #7a7168;
  text-align: right;
  line-height: 1.3;
  font-weight: 500;
}

.chevron {
  display: flex;
  align-items: center;
}

.progress-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  min-width: 68px;
}

.progress-bar {
  width: 68px;
  height: 4px;
  background: #e8e4de;
  border-radius: 10px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #16a34a;
  border-radius: 10px;
}

.progress-label {
  font-size: 11px;
  font-weight: 700;
  color: #16a34a;
}

.cours-dialog-desc {
  margin: 0 0 14px;
  font-size: 13px;
  color: #7a7168;
}
</style>
